"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var expressionOfInterest = {
    EXPRESSIONS_OF_INTEREST: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment ExpressionOfInterest on ExpressionOfInterest {\n      code\n      enabled\n      attributes {\n        picture\n        label\n        description\n      }\n    }\n  "], ["\n    fragment ExpressionOfInterest on ExpressionOfInterest {\n      code\n      enabled\n      attributes {\n        picture\n        label\n        description\n      }\n    }\n  "]))),
};
exports.default = expressionOfInterest;
var templateObject_1;
